export function checkIsDebugger(){return new Promise(function(resolve,reject){var devtools=/./;devtools.toString=function(){resolve(true);return'';};});}